import type { ProfilerOnRenderCallback } from "react";

import { Timings } from "@storyboard/web-logger/timings/Timings";
import { flightRecorder } from "@/services/debug/FlightRecorder";
import { RenderMetricsService, SLOW_RENDER_MS } from "./RenderMetricsService";

/**
 * Shared React `<Profiler onRender>` callback. Counts every commit into {@link RenderMetricsService}
 * (cheap, gated) and the flight recorder (debug mode only), and emits a `react-render:<id>` Timing
 * span only for slow commits so the User Timing / Honeycomb streams aren't flooded.
 */
export const profilerOnRender: ProfilerOnRenderCallback = (id, phase, actualDuration) => {
  RenderMetricsService.record(id, phase, actualDuration);
  flightRecorder.recordCommit(id, phase, actualDuration);
  if (actualDuration > SLOW_RENDER_MS) {
    Timings.createSpan(`react-render:${id}`, performance.now() - actualDuration, performance.now(), {
      properties: { phase, duration: actualDuration },
    });
  }
};
